module.exports = __webpack_public_path__ + "static/media/oops.b3985011.png";